var map = {
	"./add-contact-icon.svg": 231,
	"./add-icon.svg": 232,
	"./add.svg": 918,
	"./alert-icon.svg": 233,
	"./amex.svg": 919,
	"./arrow-down.svg": 920,
	"./arrow-left.svg": 921,
	"./arrow.svg": 922,
	"./back-icon.svg": 147,
	"./background.svg": 923,
	"./bars.svg": 924,
	"./box.svg": 925,
	"./bullet.svg": 926,
	"./calendar-icon.svg": 37,
	"./calendar.svg": 927,
	"./call-icon.svg": 234,
	"./campaigns-running-icon.svg": 148,
	"./color.svg": 928,
	"./comming-soon.svg": 381,
	"./connect-icon-inactive.svg": 382,
	"./connect-icon.svg": 29,
	"./connected.svg": 929,
	"./continue-icon.svg": 149,
	"./create-campaign-icon.svg": 235,
	"./crm-icon-inactive.svg": 383,
	"./crm-icon.svg": 62,
	"./customer-icon-inactive.svg": 384,
	"./customer-icon.svg": 73,
	"./dashboard-icon-inactive.svg": 385,
	"./dashboard-icon.svg": 115,
	"./dashboard-subitem-icon.svg": 236,
	"./date-icon.svg": 237,
	"./delete-icon.svg": 238,
	"./delete.svg": 110,
	"./design-icon.svg": 239,
	"./device-icon.svg": 240,
	"./device-item-icon.svg": 241,
	"./devices-icon.svg": 242,
	"./done.svg": 371,
	"./dot-not-selected.svg": 930,
	"./dot-selected.svg": 931,
	"./dots.svg": 932,
	"./download-qr-icon.svg": 243,
	"./drop-down-icon.svg": 244,
	"./dropdown-icon-down.svg": 933,
	"./dropdown-icon-up.svg": 934,
	"./dropdown-icon.svg": 245,
	"./edit-btn.svg": 935,
	"./edit-icon.svg": 246,
	"./edit.svg": 386,
	"./email-creator.svg": 282,
	"./email-icon.svg": 247,
	"./email-login.svg": 317,
	"./emails-icon.svg": 150,
	"./eye-show.svg": 936,
	"./eye.svg": 937,
	"./facebook-icon.svg": 248,
	"./facebook.svg": 938,
	"./fanicon.svg": 939,
	"./fb-login.svg": 316,
	"./female.svg": 314,
	"./full-icon.svg": 116,
	"./info.svg": 940,
	"./instagram.svg": 941,
	"./integration.svg": 942,
	"./interface.svg": 943,
	"./label-icon.svg": 249,
	"./landing-page-icon.svg": 250,
	"./left-arrow.svg": 944,
	"./linkedin-icon.svg": 251,
	"./location.svg": 945,
	"./log-out-icon.svg": 252,
	"./login.svg": 946,
	"./mail.svg": 947,
	"./mailchimp.svg": 948,
	"./male.svg": 313,
	"./manage-campaign-icon.svg": 253,
	"./manage-campaigns-icon.svg": 254,
	"./marketing-icon-inactive.svg": 949,
	"./marketing-icon.svg": 74,
	"./mastercard.svg": 950,
	"./menu-btn.svg": 951,
	"./menu.svg": 952,
	"./message-container.svg": 953,
	"./message-preview.svg": 954,
	"./messagebird.svg": 376,
	"./mobile.svg": 955,
	"./network-icon.svg": 255,
	"./nfc.svg": 956,
	"./not-found.svg": 957,
	"./org-dashboard.svg": 958,
	"./org-delete.svg": 959,
	"./org-edit.svg": 960,
	"./org-info.svg": 961,
	"./org-suspend.svg": 962,
	"./payment-failed.svg": 379,
	"./payment-success.svg": 380,
	"./paypal.svg": 963,
	"./person-icon.svg": 75,
	"./phone-icon.svg": 97,
	"./phone.svg": 964,
	"./pin.svg": 281,
	"./plan-item-icon.svg": 151,
	"./pm-delete-icon.svg": 152,
	"./position-icon-grey.svg": 335,
	"./position-icon.svg": 51,
	"./profile.svg": 965,
	"./registration-drop-down-icon.svg": 256,
	"./remember-me-box-selected.svg": 966,
	"./remember-me-box.svg": 967,
	"./remove-from-list.svg": 968,
	"./remove-icon.svg": 257,
	"./remove-widget-icon.svg": 40,
	"./remove.svg": 969,
	"./reports-icon.svg": 258,
	"./retry-icon.svg": 153,
	"./right-arrow.svg": 970,
	"./search-icon.svg": 154,
	"./search.svg": 971,
	"./selected.svg": 972,
	"./send-icon-inactive.svg": 387,
	"./send-icon.svg": 63,
	"./sendgrid-full.svg": 377,
	"./settings-icon.svg": 155,
	"./shop.svg": 211,
	"./show-password.svg": 973,
	"./small-icon.svg": 114,
	"./sms-contacts-icon.svg": 259,
	"./sms-icon-inactive.svg": 388,
	"./sms-icon.svg": 41,
	"./support-icon.svg": 156,
	"./switch-off.svg": 363,
	"./switch-on.svg": 364,
	"./symbols.svg": 974,
	"./tag.svg": 389,
	"./texts-failed-icon.svg": 157,
	"./total-sent-icon.svg": 158,
	"./total-sms-contacts-icon.svg": 159,
	"./track&trace.svg": 975,
	"./tt-icon.svg": 160,
	"./twitter-icon.svg": 260,
	"./twitter-login.svg": 315,
	"./twitter.svg": 976,
	"./unaro-full-icon.svg": 98,
	"./unaro-full.svg": 977,
	"./unaro-main.svg": 146,
	"./unaro-yellow-background.svg": 978,
	"./unaro-yellow-bg copy.svg": 979,
	"./unaro-yellow-bg.svg": 980,
	"./unaro.svg": 981,
	"./unselected.svg": 982,
	"./upload-icon.svg": 161,
	"./uploaded-file-icon.svg": 162,
	"./user.svg": 370,
	"./users-icon.svg": 261,
	"./venues.svg": 983,
	"./verify-icon.svg": 262,
	"./visa.svg": 984,
	"./widgets/connect-chart.svg": 330,
	"./widgets/customer-logins.svg": 329,
	"./widgets/customers.svg": 334,
	"./widgets/demographics.svg": 328,
	"./widgets/emails-collected.svg": 327,
	"./widgets/sms-campaigns-list.svg": 333,
	"./widgets/sms-campaigns.svg": 332,
	"./widgets/sms-sent.svg": 331,
	"./widgets/sms-spent.svg": 985,
	"./wifi-icon.svg": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 917;